export interface GraphApiData<DataType> {
  value: DataType;
}

/**
 * User Profile interface with data coming back from azure graph
 * ** Some of the attributes are missing, you can add them as we use them.
 */
export interface UserProfile {
  city: string;
  companyName: string;
  country: string;
  displayName: string;
  givenName: string;
  mail: string;
  mailNickname: string;
  objectId: string;
  surname: string;
  usageLocation: string;
  userType: string;
  lastDirSyncTime: string;
  userPrincipalName: string;
  manager?: UserProfile;
  thumbnailPhotoUrl?: string;
  userState?: ExternalUserState;
}

export enum ExternalUserState {
  PENDING_ACCEPTANCE = 'PendingAcceptance',
  ACCEPTED = 'Accepted'
}

export interface UserGraphApiData extends GraphApiData<UserProfile[]> {}
